export default __webpack_public_path__ + "static/media/cfd1.cd9f1473.png";